module.exports = __webpack_public_path__ + "img/mensaje.900adac7.svg";